import { render } from "./TransactionStatus1Panel.vue?vue&type=template&id=ff3aa6f6&scoped=true&ts=true"
import script from "./TransactionStatus1Panel.vue?vue&type=script&lang=ts"
export * from "./TransactionStatus1Panel.vue?vue&type=script&lang=ts"

import "./TransactionStatus1Panel.vue?vue&type=style&index=0&id=ff3aa6f6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3aa6f6"]])

export default __exports__